import { domNotify } from "@domNotify";

class Notify {

  static extractMessage(res) {
    const raw =
      res?.response?.data?.message ??
      res?.data?.messages ??
      res?.messages ??
      res?.response?.data?.data?.message ??
      null; //TODO: rehandle direct string
      return raw?.split(",").map((m) => m.trim()).join("<div></div>") ?? null;
  }

  static Success({ res, title, message } = {}) {
    domNotify({
      type: "success",
      title: title || "Success",
      text: (res ? this.extractMessage(res) : message) || "Operation Completed Successfully."
    });
  }

  static Error({ res, title, message } = {}) {
    const response = res?.response?.data
    const status = response?.status ?? response?.data?.status
    // Matches every backend wording: "...related to another record / linked to other records / is related to ... and cannot be deleted."
    const isNotAvailableForDeletion = response?.message?.includes("cannot be deleted")
    if (status === "warning" || isNotAvailableForDeletion) return this.Warning({ res });
    domNotify({
      type: "error",
      title: title || "Validation",
      text: (res ? this.extractMessage(res) : message) || "An Error Has Occurred While Processing."
    });
  }

  static Loading({ res, title, message } = {}) {
    domNotify({
      type: "info",
      title: title || "Loading",
      text: (res ? this.extractMessage(res) : message) || "Please Wait..."
    });
  }

  static Warning({ res, title, message } = {}) {
    domNotify({
      type: "warning",
      title: title || "Warning",
      text: (res ? this.extractMessage(res) : message) || "Please Check Your Input."
    });
  }

  static Custom(options = {}) {
    domNotify({
      type: options?.type || "info",
      title: options?.title || "",
      text: options?.text || "",
      ...options
    });
  }
}

export default Notify;
